import styles from './LastUpdatedTimeStamp.module.css';
import { formatUnixTimestampToObject } from '@/utils/dateUtils';

const LastUpdatedTimeStamp = ({ timestamp }) => {
  if (!timestamp) {
    return null;
  }

  const {
    dateNumber,
    suffix,
    hours,
    minutes,
    ampm,
    formattedMinutes,
    year,
    monthNumber
  } = formatUnixTimestampToObject(timestamp);

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <span className={styles.text}>
          Inventory last updated <span className={styles.boldText}>{
            `${monthNumber}/${dateNumber}/${year}`
          }</span> at <span className={styles.boldText}>{
            `${hours}:${formattedMinutes}${ampm}`
          }</span>
        </span>
      </div>
    </div>
  );
};

export default LastUpdatedTimeStamp;